import { IRequisitionService } from './IRequisitionService';
import { of as observableOf, Observable } from 'rxjs';
import { HttpRequestService } from '../../http-request.service';
import { apiURLs , PREVILEGEKEY} from '../../../globalcontants';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequisitionEntity } from '../../../models/Transactions/RequisitionEntity';
import { ValidationEntity } from '../../../models/Utilities/ValidationEntity';


@Injectable({
  providedIn: 'root'
})
export class RequisitionService implements IRequisitionService {
  constructor(private httpService: HttpRequestService) { }
  /**
   * @version UI 13.2
   * @method GetTransRequisitionSummary;
   */
  GetTransRequisitionSummary(RequisitionRequestParams: any): Observable<any> {
    const requisitionRequestUrl = apiURLs.TransactionManagement.GetRequisitionHead + RequisitionRequestParams;
    return this.httpService.GetHttpRequest(requisitionRequestUrl);
  }

  /**
   * @version UI 24.3
   * @method GetAllRequisitions;
   */
  GetAllRequisitions(RequisitionRequestPayload: any): Observable<any> {
    const requisitionRequestUrl = apiURLs.TransactionManagement.GetAllRequisitions;
    return this.httpService.postHttpRequest(requisitionRequestUrl, RequisitionRequestPayload);
  }

  GetRequisitionSummary(
    siteId: number,
    transType: number,
    menuId: number,
    selectedLocationId: number = 0,
    itemId: number = 0,
    searchText: string = ''): Observable<RequisitionEntity[]> {
    let inputParams = new HttpParams().set('siteId', siteId.toString())
      .set('transType', transType.toString())
      .set('menuId', menuId.toString())
      .set('selectedLocationId', selectedLocationId.toString())
      .set('itemId', itemId.toString())
      .set('APIKEY', PREVILEGEKEY.GetRequisitionSummary);
    if (searchText !== '') {
      inputParams = inputParams.append('searchValue', searchText.toString());
    }
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.RequisitionAPI.GetRequisitionSummary);
  }

  GetRequisitionDetails(transType: number, menuId: number, requisitionNumber: number, userId: number = 0, siteId: number = 0)
  : Observable<RequisitionEntity> {
    const inputParams = new HttpParams()
    .set('transType', transType.toString())
    .set('menuId', menuId.toString())
    .set('requisitionNumber', requisitionNumber.toString())
    .set('userId', userId.toString())
    .set('siteId', siteId.toString());
   // return this.httpService.GetHttpRequestId(inputParams, apiURLs.RequisitionAPI.GetRequisitionDetails);
      return this.httpService.GetHttpRequestId(inputParams, apiURLs.TransactionManagement.GetRequisitionHead);
  }


  /**
   * @version 13.2 UI
   * @method GetReqDetails
   * @param transTypeId;
   * @param requistionId;
   * @returns;
   */

  GetReqDetails(transTypeId: number, requistionId: number): Observable<any> {
    const reqHeadUrl = `${apiURLs.TransactionManagement.GetRequisitionHead}/` + requistionId + `?transtype=${transTypeId}`;
    return this.httpService.GetHttpRequest(reqHeadUrl);
  }

  PostRequisition(entity: any): Observable<ValidationEntity> {
    if(entity.Id) {
      return this.httpService.putHttpRequest(apiURLs.TransactionManagement.GetRequisitionHead + `/${entity.Id}` , entity);
    } else {
      return this.httpService.postHttpRequest(apiURLs.TransactionManagement.GetRequisitionHead, entity);
    }
  }

  
  /**
   * @version 13.2.6 UI Delivery Rule
   * @method CheckDeliveryRule
   * @param Entity;
   * @returns;
   */
  CheckDeliveryRule(entity: any, entityName:string): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.TransactionManagement.CheckDeliveryRule +`/${entityName}`, entity);
  }
  RequisitionPost(entity: RequisitionEntity): Observable<ValidationEntity> {
    (entity as any).APIKEY = PREVILEGEKEY.PostRequisition;
    return this.httpService.postHttpRequest(apiURLs.RequisitionAPI.SaveRequisition, entity);
  }

  // GetNewReqTableDetails(transTypeID: number, functionMenuId: number, requisitionId: number, userId: number = 0, siteId: number = 0)
  // : Observable<RequisitionEntity> {
  //   const inputParams = new HttpParams()
  //   .set('transType', transTypeID.toString())
  //   .set('menuId', functionMenuId.toString())
  //   .set('requisitionNumber', requisitionId.toString())
  //   .set('userId', userId.toString())
  //   .set('siteId', siteId.toString());
  //   return this.httpService.GetHttpRequestId(inputParams, apiURLs.InvertoryManagement.GetTransferReqHead);
  // }
  GetNewReqTableDetails(requistionId: number, transTypeId: number): Observable<any> {
    const reqHeadUrl = `${apiURLs.TransactionManagement.GetRequisitionHead}/` + requistionId + `?transtype=${transTypeId}`;
    return this.httpService.GetHttpRequest(reqHeadUrl);
  }
}
